import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';
import { UserRoles } from '../dictionaries/UserRoles';

@Injectable({
  providedIn: 'root'
})
export class SuperuserGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    const current = this.authService.userData.getValue() as any;
    if (current?.role) {
      return current.role === UserRoles.superuser ? true : this.router.createUrlTree(['/']);
    }
    // userData not yet populated — wait for first emission with a role
    return this.authService.userData.pipe(
      filter((user: any) => !!user?.role),
      take(1),
      map((user: any) => user.role === UserRoles.superuser ? true : this.router.createUrlTree(['/']))
    );
  }
}
